import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import SellDeliveryNoteStatusBar, { SellDeliveryNoteStatusBarNew, SellDeliveryNoteStatusBarProps } from '../../../SellDeliveryNStatusBar'
import SellDeliveryNoteCreateNoPermissionButtons, { SellDeliveryNoteCreateNoPermissionButtonsNew } from '../SellDeliveryNCreateNoPermissionButtons'

type SellDeliveryNoteCreateNoPermissionStepHeaderProps = & SellDeliveryNoteStatusBarProps & OrderStepButtonsBaseComponentProps

const SellDeliveryNoteCreateNoPermissionStepHeaderDecider: React.FC<SellDeliveryNoteCreateNoPermissionStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={SellDeliveryNoteCreateNoPermissionStepHeaderDefault} NewComponent={SellDeliveryNoteCreateNoPermissionStepHeaderNew} {...rest} />
    )
}

const SellDeliveryNoteCreateNoPermissionStepHeaderDefault: React.FC<SellDeliveryNoteCreateNoPermissionStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <SellDeliveryNoteStatusBar {...rest} />
            <SellDeliveryNoteCreateNoPermissionButtons {...rest} />
        </div>
    )
}

const SellDeliveryNoteCreateNoPermissionStepHeaderNew: React.FC<SellDeliveryNoteCreateNoPermissionStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <SellDeliveryNoteStatusBarNew {...rest} />
            <SellDeliveryNoteCreateNoPermissionButtonsNew {...rest} />
        </Fragment>
    )
}

export default SellDeliveryNoteCreateNoPermissionStepHeaderDecider